import { useCallback, useRef } from 'react'

import { JSONContent } from '@tiptap/core'

import { TipTapEditorHandle } from 'features/tiptap/TipTapEditor'
import { useTipTapDocumentContent } from 'features/tiptap/useTipTapDocumentContent'
import { getRichTextValue } from 'features/views/attributes/editable/utils'
import { RichTextValue } from 'features/views/attributes/types'

type UseSectionRichTextAttributeEditorStateProps = {
    value?: RichTextValue | null
    onChange: (value: RichTextValue | null) => void
}

export function useSectionRichTextAttributeEditorState({
    value,
    onChange,
}: UseSectionRichTextAttributeEditorStateProps) {
    const editorRef = useRef<TipTapEditorHandle>(null)

    const localValue = useTipTapDocumentContent({
        content: value?.content ?? null,
        format: value?.format ?? 'tiptap',
    })

    const handleChange = useCallback(
        (value: JSONContent | null) => {
            const editor = editorRef.current?.editor
            if (!editor) return

            const newValue = getRichTextValue(value, editor)
            onChange(newValue)
        },
        [onChange]
    )

    return {
        editorRef,
        localValue,
        handleChange,
    }
}
